import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const customerSettingsService = {
    salesforceAuthorize: (companyId) => 
    {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.SLAESFORCE}/${API_PATH.OAUTH2}/${API_PATH.AUTORIZE}/${companyId}`)
    },
    salesforceoceAuthorize: (companyId) => 
    {   
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.SLAESFORCE}/${API_PATH.OCE}/${API_PATH.OAUTH2}/${API_PATH.AUTORIZE}/${companyId}`)
    },
    testAuth: (companyId, data) => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.MARKETOAUTH}/${API_PATH.TESTAUTH}`, data)
    },
    saveMarkToAuth: (companyId, data) => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.MARKETOAUTH}`, data)
    }

}

export default customerSettingsService;
